import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import { visuallyHidden } from '@mui/utils';
import { Button, Checkbox, Divider, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Select, Switch, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import CommentDrawer from '../Common/Drawer';
import { capitalizeWords, ROWS_PER_PAGE } from '../../utils/constant';
import { formatDate } from '../../utils/helper';
import Confirmation from '../Common/Confirmation';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import CommonTabs from '../Common/CommonTabs';
import { deleteContact, fetchContacts, toggleActivation } from '../../store/contactSlice';
import { useEffect } from 'react';
import { fetchDomainList, fetchDomains } from '../../store/domainSlice';
import ContactLeadExport from '../lead/ContactLeadExport';
import { fetchClientList, fetchClients } from '../../store/clientSlice';
import { useLocation, useSearchParams } from 'react-router-dom';
import { NoData } from '../Common/NoData';
import ReadMoreArea from '@foxeian/react-read-more';
import ViewMorePopover from '../Common/ReadMoreLess';

function createData(uuid, id, name, email, phone, location, createdAt, active, actions) {
    return {
        uuid,
        id,

        name,
        email,
        phone,
        location,
        createdAt,
        active,
        actions
    };
}

const LeadActions = ({ page, setPage, getContacts, lead, canDelete }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const dispatch = useDispatch()

    const handleDelete = async (id) => {
        try {
            dispatch(deleteContact(id)).then(res => {
                getContacts()
                // if(page){
                //     setPage(0)
                // }else{
                // }
            })
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <>
            <Grid spacing={4} justifyContent={'flex-end'}>
                <Grid size={8}>
                    <CommentDrawer {...{ open, setOpen }} >
                        <Box className="p-3">
                            <Typography variant="h6" gutterBottom>
                                Lead Detail
                            </Typography>
                            <Divider />
                            <div className='role-form-scroller'>
                                <TableContainer component={Paper} className="mt-3">
                                    <Table aria-label="lead details table">
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>  <Typography className='table-detail-cells-head' variant='body2'>Name:</Typography></TableCell>
                                                <TableCell className='td-keyval'>{lead.name || "N/A"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>  <Typography className='table-detail-cells-head' variant='body2'>Email:</Typography></TableCell>
                                                <TableCell>{lead.email || "N/A"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>  <Typography className='table-detail-cells-head' variant='body2'>Phone:</Typography></TableCell>
                                                <TableCell className='td-keyval'>{lead.phone || "N/A"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>  <Typography className='table-detail-cells-head' variant='body2'>Location:</Typography></TableCell>
                                                <TableCell className='td-keyval'>{lead.address || "N/A"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>  <Typography className='table-detail-cells-head' variant='body2'>Landing Page:</Typography></TableCell>
                                                <TableCell className='td-keyval'>
                                                    {lead?.landing_page?.route ? <a href={lead?.landing_page?.route} target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: 'underline' }}>
                                                        <Typography color='primary' variant='body2'>   {lead?.landing_page?.route}</Typography>
                                                    </a> : <>N/A</>}
                                                    {/* {lead?.landing_page?.route || "N/A"} */}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>  <Typography  className='table-detail-cells-head' variant='body2'>Message:</Typography></TableCell>
                                                <TableCell className='td-keyval'>{lead.query || "N/A"}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Box>
                        <Box className="drawer-footer m-3">
                            <Button
                                type="button"
                                variant="outlined"
                                color="primary"
                                onClick={() => setOpen(false)}
                                className="mt-2 mr-2"
                            >
                                close
                            </Button>
                        </Box>
                    </CommentDrawer>
                    <Box gap={2} display='flex' className="table-margin">
                        <RemoveRedEyeOutlinedIcon className='link-color' onClick={(event) => {
                            event.stopPropagation();
                            setOpen(true);
                        }} />
                        <DeleteOutlineOutlinedIcon className={`${!canDelete ? 'icon-disabled danger-color' : 'danger-color'}`} onClick={() => {
                            if (canDelete)
                                setIsOpen(true)
                        }} />
                    </Box>
                    <>
                        <Confirmation open={isOpen} setOpen={setIsOpen} msg={"Are you sure you want to delete this Lead"} yesClick={() => { handleDelete(lead.uuid); setIsOpen(false) }} />
                    </>
                </Grid>
            </Grid>
        </>
    )
}

const headCells = [
    {
        label: 'Name',
        numeric: false,
        disablePadding: false,
        id: 'name',
        sortable: true
    },
    {
        label: 'Email',
        numeric: false,
        disablePadding: false,
        id: 'email',
        sortable: true
    },
    {
        label: 'Phone',
        numeric: false,
        disablePadding: false,
        id: 'phone',
        sortable: true
    },
    {
        label: 'Location',
        numeric: false,
        disablePadding: false,
        id: 'address',
        sortable: true
    },
    {
        label: 'Created At',
        numeric: false,
        disablePadding: false,
        id: 'created_at',
        sortable: true
    },
    {
        label: 'Active',
        numeric: false,
        disablePadding: false,
        id: 'active',
        sortable: false
    },
    {
        label: 'Actions',
        numeric: false,
        disablePadding: false,
        id: 'actions',
        sortable: false
    },
];

function EnhancedTableHead(props) {
    const { setOrdering, orderingState, setOrderingState, tabValue, numSelected, rowCount, onSelectAllClick } =
        props;

    const createSortHandler = (property) => (event) => {
        const orderData = orderingState
        const exists = orderData?.find((item) => item.id === property);
        const updated = (() => {
            if (exists) {
                return orderData.map((item) =>
                    item.id === property
                        ? { ...item, order: item.order === "asc" ? "desc" : "asc" }
                        : item
                );
            } else {
                return [...orderData, { id: property, order: "asc" }];
            }
        })();
        setOrderingState(updated)

    };

    React.useEffect(() => {
        const ordering = orderingState.map((item) => {
            return item.order === "asc" ? item.id : "-" + item.id;
        });
        if (ordering?.length) {
            setOrdering(ordering.join(","));
        }
    }, [orderingState]);

    const removeFilter = (property) => {
        const data = orderingState.filter((item) => item.id !== property)
        setOrderingState(data)
    }
    return (
        <TableHead>
            <TableRow>
                {tabValue === 0 && <TableCell padding="checkbox">
                    <Checkbox
                        size='small'
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            "aria-label": "select all leads",
                        }}
                    />
                </TableCell>}
                {headCells.map((headCell) => {
                    const key = headCell.id;
                    const sortObj = orderingState.find((item) => item.id === key);
                    const isSorted = !!sortObj;
                    const sortDirection = sortObj?.order || "asc";
                    return (
                        <TableCell
                            className='font-weight'
                            key={key}
                            align={headCell.numeric ? "left" : "left"}
                            padding={headCell.disablePadding ? "none" : "normal"}
                            sortDirection={isSorted ? sortDirection : false}
                        >
                            {headCell.sortable ?
                                <TableSortLabel
                                    active={isSorted}
                                    direction={sortDirection}
                                    onClick={createSortHandler(key)}
                                    color="secondary"
                                    hideSortIcon={false}
                                >
                                    {headCell.label}
                                    {isSorted && (
                                        <Box component="span" sx={visuallyHidden}>
                                            {sortDirection === "desc" ? "sorted descending" : "sorted ascending"}
                                        </Box>
                                    )}
                                    {isSorted && <FilterListOffIcon onClick={(e) => { e.stopPropagation(); removeFilter(headCell.id) }} className="ml-2" size="small" color='primary' />}
                                </TableSortLabel> : headCell.label}
                        </TableCell>)
                })}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};
function EnhancedTableToolbar(props) {
    const dispatch = useDispatch()
    // const { setSelected,selectedDomain, setSelectedDomain, tabValue, setSelectedClient ,numSelected,selected} = props
    const { getContacts, selectedDomain, setPage, selectedClient, ordering, setSelected, setSelectedDomain, tabValue, setSelectedClient, numSelected, selected, handleSelectAllClick, setToggleCallApi } = props
    const [open, setOpen] = React.useState(false)
    const [isFilter, setIsFilter] = React.useState(false)
    const [currentLandingPages, setCurrentLandingPages] = React.useState([])
    const domains = useSelector((state) => state.domainReducer.domains)
    useEffect(() => {
        dispatch(fetchDomainList())
        dispatch(fetchClientList())
    }, [])

    return (
        <>
            <Toolbar
                className='main-list-toolbar'
            >
                <Typography
                    className="d-flex flex-grow-1 flex-shrink-1 flex-fill"
                    variant="h6"
                    id="tableTitle"
                    component="div"
                >
                    Hot Leads
                </Typography>
                {tabValue === 0 && <Tooltip title="Export">
                    <Button
                        className='ml-2'
                        variant="contained"
                        onClick={() => {
                            setIsFilter(false)
                            setOpen(true)
                        }}
                    >
                        Export
                    </Button>
                </Tooltip>}
                <Tooltip title="Filter">
                    <Button
                        className='ml-2'
                        variant="contained"
                        onClick={() => {
                            setIsFilter(true)
                            setOpen(true)
                        }}
                    >
                        Filter
                    </Button>
                </Tooltip>
            </Toolbar>
            <CommentDrawer {...{ open, setOpen }} className="p-3" >
                <ContactLeadExport {...{ setPage, getContacts, setSelected, open, numSelected, selected, setOpen, currentLandingPages, setCurrentLandingPages, isFilter, selectedDomain, selectedClient, ordering, tabValue, setSelectedClient, setSelectedDomain, handleSelectAllClick, setToggleCallApi }} />
                {/* <ContactLeadExport {...{ setSelected, open, numSelected, selected, setOpen, currentLandingPages, setCurrentLandingPages, isFilter, tabValue, setSelectedClient, selectedDomain, setSelectedDomain }} /> */}
            </CommentDrawer>

        </>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

export default function ContactLeadManage() {
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('created_at');
    const [ordering, setOrdering] = React.useState();
    const [selected, setSelected] = React.useState([]);
    const [rows, setRows] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [leadSectiontype, setLeadSectiontype] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(ROWS_PER_PAGE);
    const [leadModal, setLeadModal] = React.useState(false);
    const [selectedLead, setSelectedLead] = React.useState({});
    const [selectedClient, setSelectedClient] = React.useState();
    const [resetTrigger, setResetTrigger] = React.useState(false);
    const [tabValue, setTabValue] = React.useState(0);
    const [toggleCallApi, setToggleCallApi] = React.useState(false)
    const [opneActiveConfirm, setOpneActiveConfirm] = React.useState(false);
    const leads = useSelector((state) => state.contactReducer.contacts)
    const loading = useSelector((state) => state.contactReducer.loading)
    const count = useSelector((state) => state.contactReducer.count)
    const userPermission = useSelector((state) => state.userReducer.userPermission)
    const leadPermissions = userPermission.find((perm) => perm.model_name === "leads")?.permissions || [];
    const [orderingState, setOrderingState] = React.useState([])
    const [selectedDomain, setSelectedDomain] = React.useState([])
    const [searchParams] = useSearchParams();
    let canEdit = leadPermissions.includes("change");
    const location = useLocation();
    let canDelete = leadPermissions.includes("delete");
    const dispatch = useDispatch()

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        const ordering = isAsc ? "-" + property : property
        setOrdering(ordering)
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.uuid);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const label = { inputProps: { 'aria-label': 'Color switch demo' } };
    console.log("loading", loading);

    React.useEffect(() => {
        const rowData = leads?.map((ele) => {
            return createData(ele.uuid, ele.id, ele.name, ele.email, ele.phone, ele.address, ele?.created_at, <Switch disabled={loading} className={`${!canEdit && 'icon-disabled'}`} checked={ele.deactivated_on ? false : true} {...label} onClick={(e) => {
                if (canEdit) {
                    setSelectedLead(ele)
                    if (!ele?.deactivated_on) {
                        setOpneActiveConfirm(true)
                    } else {
                        dispatch(toggleActivation(ele.uuid))
                    }
                }
            }} />, <LeadActions {...{ page, setPage, getContacts, leadModal, setLeadModal, setSelectedLead, canDelete, canEdit }} lead={ele} />)
        })
        setRows(rowData)
    }, [leads, loading])

    React.useEffect(() => {
        const domain = location?.state?.domainId
        dispatch(fetchContacts(`?page=${page + 1}&page_size=${rowsPerPage}&ordering=${ordering ? ordering : ""}&is_sold=${tabValue ? true : false}${selectedDomain?.length ? `&landing_page=${selectedDomain.join(",")}` : domain ? `&landing_page=${domain}` : ""}${selectedClient && tabValue ? `&sold_to=${selectedClient}` : ""}`))
    }, [tabValue, rowsPerPage, page, ordering, selectedDomain, selectedClient, toggleCallApi])

    const getContacts = async () => {
        dispatch(fetchContacts(`?page=${page + 1}&page_size=${rowsPerPage}&ordering=${ordering}&is_sold=${tabValue ? true : false}${selectedDomain?.length ? `&landing_page=${selectedDomain.join(",")}` : ""}${selectedClient && tabValue ? `&sold_to=${selectedClient}` : ""}`))
    }
    useEffect(() => {
        const domainFromURL = location.state?.domainId;
        console.log("domainFromURL", domainFromURL);
        if (domainFromURL) {
            setSelectedDomain([domainFromURL]);
        }
    }, [])

    useEffect(() => {
        // setPage(0)
        setSelectedClient('')
    }, [tabValue])

    // const visibleRows = React.useMemo(() => {
    //     if (rows?.length) {
    //         return [...rows]

    //     }
    // }, [rows]);
    const handleClick = (event, uuid) => {
        const selectedIndex = selected.indexOf(uuid);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, uuid);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        setSelected(newSelected);
    };
    const isSelected = (uuid) => selected.indexOf(uuid) !== -1;
    function Row(props) {
        const { row, labelId } = props;

        const isItemSelected = isSelected(row.uuid);
        return (
            <React.Fragment>
                <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={row.id}
                    id={labelId}
                    className='cursor-pointer'
                    selected={isItemSelected}

                >
                    {tabValue === 0 && <TableCell padding="checkbox" onClick={(event) => handleClick(event, row.uuid)}>
                        <Checkbox
                            size='small'
                            color="primary"
                            checked={isItemSelected}
                            inputProps={{
                                "aria-labelledby": `enhanced-table-checkbox-${labelId}`,
                            }}
                        />
                    </TableCell>}
                    <TableCell align="left">
                        {row?.name ? (
                            row.name.length > 20 ? (
                                <Tooltip title={capitalizeWords(row.name)} arrow>
                                    <span>{capitalizeWords(row.name.slice(0, 17))}...</span>
                                </Tooltip>
                            ) : (
                                <span>{capitalizeWords(row.name)}</span>
                            )
                        ) : (
                            "N/A"
                        )}
                    </TableCell>

                    <TableCell align="left">
                        {row?.email ? (
                            row.email.length > 30 ? (
                                <Tooltip title={row.email} arrow>
                                    <span>{row.email.slice(0, 25)}...</span>
                                </Tooltip>
                            ) : (
                                <span>{row.email}</span>
                            )
                        ) : (
                            "N/A"
                        )}
                    </TableCell>
                    <TableCell align="left">{row.phone || "N/A"}</TableCell>
                    <TableCell align="left">
                        {row?.location ? (
                            row.location.length > 20 ? (
                                <Tooltip title={row.location} arrow>
                                    <span>{row.location.slice(0, 20)}...</span>
                                </Tooltip>
                            ) : (
                                <span>{row.location}</span>
                            )
                        ) : (
                            "N/A"
                        )}
                    </TableCell>
                    <TableCell align="left">{formatDate(row.createdAt)}</TableCell>
                    <TableCell align="left">{row.active}</TableCell>
                    <TableCell align="left">{row.actions}</TableCell>
                </TableRow>

            </React.Fragment >
        );
    }

    return (
        <Box className='w-100'>
            <Confirmation open={opneActiveConfirm} setOpen={setOpneActiveConfirm} msg={"Are you sure you want to Inactive this Lead"} yesClick={() => { dispatch(toggleActivation(selectedLead.uuid)); setOpneActiveConfirm(false) }} />
            <Paper className="w-100 mb-2" >
                {/* <EnhancedTableToolbar numSelected={selected.length} selected={selected} {...{ setSelected, setSelectedClient, selectedDomain, setSelectedDomain, tabValue, leadSectiontype, setLeadSectiontype, leadModal, setLeadModal, setSelectedLead, selectedLead, setResetTrigger, resetTrigger }} /> */}
                <EnhancedTableToolbar numSelected={selected.length} selected={selected} {...{ getContacts, page, setPage, handleSelectAllClick, setSelected, setSelectedClient, selectedDomain, selectedClient, ordering, setSelectedDomain, tabValue, leadSectiontype, setLeadSectiontype, leadModal, setLeadModal, setSelectedLead, selectedLead, setResetTrigger, resetTrigger, setToggleCallApi }} />
                {loading && <LinearProgress />}
                <CommonTabs {...{ tabValue, setTabValue, setPage }}>
                    <TableContainer className='position-relative'>
                        <Table
                            className='min-width-750'
                            aria-labelledby="tableTitle"
                            size={'small'}
                        >
                            <EnhancedTableHead
                                orderingState={orderingState}
                                setOrderingState={setOrderingState}
                                numSelected={selected.length}
                                order={order}
                                setOrdering={setOrdering}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={rows?.length}
                                tabValue={tabValue}
                            />
                            <TableBody>
                                {rows?.map((row, index) => {
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    return (
                                        <>
                                            <Row row={row} label={labelId} />
                                        </>
                                    );
                                })}
                            </TableBody>
                        </Table>
                        {!leads?.length && !loading && <NoData></NoData>}
                    </TableContainer>
                </CommonTabs>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={count}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box>
    );
}
